import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { ContaClientes } from 'src/app/admihair/api/dto/conta-clientes';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-central-cliente-conta-listar',
  templateUrl: './central-cliente-conta-listar.component.html',
  styleUrls: ['./central-cliente-conta-listar.component.scss']
})
export class CentralClienteContaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = true;
  contasClientes: ContaClientes[] = [];
  itensPaginados?: Paginador<ContaClientes>;
  numeroPagina: number = 0;
  inputBusca?: string = '';
  ordenacao: string = 'nomeCliente,ASC';
  tamanhoPagina: number = 10;


  constructor(private clienteService: ClienteService,
    erroService: ErroService,
    storageService: UtilStorageService
  ) {
    super(erroService, storageService)
  }

  ngOnInit(): void {
    //this.listarContas();
  }

  onLazyLoad(event: LazyLoadEvent) {
      if(event.first !== undefined && event.rows !== undefined) {
        if (event.first === 0 && event.rows === 0) {
          this.numeroPagina = 0;
        } else {
          this.numeroPagina = event.first / event.rows;
        }
      }
      this.definirOrdenacao(event.sortField, event.sortOrder);
      
      this.listarContas();
    }
  
    definirOrdenacao(sortField?: string, sortOrder?: number) {
      const campoDeOrdenacao = sortField ? sortField : 'nomeCliente';
      const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    }

  listarContas() {
    this.loading = true;
    this.clienteService.listarContaClientesPorEmpresa(this.getEmpresa().id, this.numeroPagina,
    this.tamanhoPagina, this.ordenacao, this.inputBusca).subscribe({
      next: (data: Paginador<ContaClientes>) => {
        this.itensPaginados = data;
        this.contasClientes = data.content;
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.listarContas();
  }

  limpar() {
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.listarContas();
  }

}
